export const onlyNumbers = (string) => {
  if(!string) return string
  return string.replace(/\D/g,'')
}

export default { onlyNumbers }
